<template>
  <div style="padding-top: 80px;">
    <TopNav activeIndex="1"></TopNav>
    <div class="banner">
      <img class="banner-img" src="../../../static/images/banner1.png" lign="middle" />
    </div>

    <div class="my-container animated fadeIn" v-show="show">
      <div class="why-lear">
        <div class="text-container">
          <div class="b-title">学习少儿编程，培养孩子的综合素质</div>
          <div class="b-line"></div>
          <div class="s-title">让孩子成为人工智能时代的领导者</div>
          <img style=" margin-top: 50px;" src="../../../static/images/img1.png" lign="middle" />
        </div>
        <div class="flex-x-between">
          <div class="item">
            <div class="item-img">
              <img src="../../../static/images/icon1.png" alt="" width="130px" />
            </div>
            <div class="item-content">
              <div class="item-title">面向中小学</div>
              <div class="item-text">
                <p>
                  教育部明确指出应在中小学设置人工智能相关课程，逐步推广编程教育，政策逐渐明朗。
                </p>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-img">
              <img src="../../../static/images/icon2.png" alt="" width="130px" />
            </div>
            <div class="item-content">
              <div class="item-title">助力中高考</div>
              <div class="item-text">
                编程正式走进高考，成为关乎孩子未来的一大必修课。参加相关赛事，各大名校直接录取。
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-img">
              <img src="../../../static/images/icon3.png" alt="" width="130px" />
            </div>
            <div class="item-content">
              <div class="item-title">掌握职业先机</div>
              <div class="item-text">
                <p>
                  学人工智能编程，前景好，就业机会多，从事互联网软件、人工智能、大数据分析、网络工程师等，行业年薪位居第一。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="why-lear">
        <div class="text-container">
          <div class="b-title">自研完善的阶梯课程体系，从启蒙至考级竞赛</div>
          <div class="b-line"></div>
          <div class="s-title">从启蒙进入，玩中学，学中玩</div>
          <div class="s-title">“数理化 语数英” 多学科知识点融合到课程体系中</div>
          <div class="s-title">多学科成绩，综合提高</div>
          <img src="../../../static/images/class.png" lign="middle" />
        </div>
      </div>
      <div class="teacher">
        <div class="teacher-container">
          <div class="text-container">
            <div class="b-title">为什么选择哆哆创客？</div>
            <div class="b-line"></div>
            <div class="s-title">核心团队来自各大超级互联网名企团队
              && 10多年研发管理经验</div>
            <div class="s-title">互联网一线研发高级工程师亲自授课</div>
          </div>

          <div class="shuju-container">
            <div class="shuju-item">
              <div class="shuju-circle" style="border: 6px solid #60d560;">
                <p class="shuju-title">自研</p>
                <p class="shuju-des">线上学生端系统</p>
              </div>
            </div>
            <div class="shuju-item">
              <div class="shuju-circle" style="border: 6px solid #ffa401;">
                <p class="shuju-title">15<span> +</span></p>
                <p class="shuju-des">线下校区和学校</p>
              </div>

            </div>
            <div class="shuju-item">
              <div class="shuju-circle" style="border: 6px solid #ff4c71;">
                <p class="shuju-title">8000<span>+</span></p>
                <p class="shuju-des">服务学员</p>
              </div>

            </div>
            <div class="shuju-item">
              <div class="shuju-circle" style="border: 6px solid #a788ff;">
                <p class="shuju-title">20000<span>+</span></p>
                <p class="shuju-des">学员作品数量</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="excellent-students">
        <div class="teacher-container">
          <div class="text-container">
            <div class="b-title">优秀学员展示风采</div>
            <div class="b-line"></div>
            <div class="s-title">优秀学员风采展示，从哆哆创客这里起航，一起驶上星辰大海。</div>
            <div class="s-title">在已经到来的人工智能时代里</div>
            <div class="s-title">让孩子能够从容、自信的应对这个时代</div>
          </div>
          <div class="swiper-container">
            <div class="student-container swiper-wrapper">
              <div :class="v.class" v-for="(v, i) in studentList" :key="i">
                <img class="student-head" :src="v.head">
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/top/TopNav'
import Footer from '@/components/bottom/Footer'
import '../../css/animate.min.css'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
var swiperMain
export default {
  components: {
    TopNav,
    Footer
  },
  data() {
    return {
      show: false,
      studentList: [
        {
          head: '../../../static/images/student/student13.jpg',
          class: 'student-item swiper-slide background1'
        },
        {
          head: '../../../static/images/student/student14.jpg',
          class: 'student-item swiper-slide background6'
        },
        {
          head: '../../../static/images/student/student15.jpg',
          class: 'student-item swiper-slide background3'
        },
        {
          head: '../../../static/images/student/student16.jpg',
          class: 'student-item swiper-slide background4'
        },
        {
          head: '../../../static/images/student/student17.jpg',
          class: 'student-item swiper-slide background1'
        },
        {
          head: '../../../static/images/student/student18.jpg',
          class: 'student-item swiper-slide background7'
        },
        {
          head: '../../../static/images/student/student1.jpg',
          class: 'student-item swiper-slide background1'
        },
        {
          head: '../../../static/images/student/student2.jpg',
          class: 'student-item swiper-slide background2'
        },
        {
          head: '../../../static/images/student/student19.jpg',
          class: 'student-item swiper-slide background7'
        },
        {
          head: '../../../static/images/student/student6.jpg',
          class: 'student-item swiper-slide background3'
        },
        {
          head: '../../../static/images/student/student3.jpg',
          class: 'student-item swiper-slide background4'
        },
        {
          head: '../../../static/images/student/student4.jpg',
          class: 'student-item swiper-slide background5'
        },
        {
          head: '../../../static/images/student/student21.jpg',
          class: 'student-item swiper-slide background6'
        },
        {
          head: '../../../static/images/student/student22.jpg',
          class: 'student-item swiper-slide background7'
        },
        {
          head: '../../../static/images/student/student8.jpg',
          class: 'student-item swiper-slide background1'
        },
        {
          head: '../../../static/images/student/student9.jpg',
          class: 'student-item swiper-slide background2'
        },
        {
          head: '../../../static/images/student/student10.jpg',
          class: 'student-item swiper-slide background3'
        },
        {
          head: '../../../static/images/student/student11.jpg',
          class: 'student-item swiper-slide background4'
        },
        {
          head: '../../../static/images/student/student20.jpg',
          class: 'student-item swiper-slide background5'
        }
      ]
    }
  },

  props: {},
  mounted() {
    this.show = true
    if (swiperMain) {
      swiperMain.destroy()
      swiperMain = null
    }
    this.initSwiper()
  },
  methods: {

    initSwiper() {
      swiperMain = new Swiper('.swiper-container', {
        observer: true,
        observeParents: true,
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: true,
        slideToClickedSlide: true,
        initialSlide: 2,
        loop: true,
        speed: 1000,
        autoplay: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    }
  }
}

</script>
<style>
@import url("./index.css");
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue